<template>
    <div class="main-layout__container">
        <div class="content__header">
            <div class="content-header__title">
                Правила АУКЦИОНА HYUNDAI
            </div>

            <div class="content-header__background"></div>
        </div>

        <div class="content__body">
            <div class="rules-page">
                <p class="rules-page__intro">
                    Настоящие Правила регулируют правоотношения между Обществом с ограниченной ответственностью «Хендэ Мотор СНГ» и Пользователями, имеющими намерение участвовать в АУКЦИОНЕ Hyundai.
                </p>
                <h2>1. Общие положения</h2>
                <p>
                    1.1. Термины и определения:
                </p>
                <p>
                    <b>Автомобиль</b> – бывший в эксплуатации легковой автомобиль марки Hyundai, находящийся в собственности у Продавца, имеющего право на продажу Автомобиля на законных основаниях
                </p>
                <p>
                    <b>Аукцион</b> – способ определения покупателя Автомобиля, при котором Победителем признаётся участник, предложивший наиболее высокую цену. Аукцион проводится в форме электронных торгов, проводимых Организатором на Сайте https://auction.hyundai.ru в форме закрытого аукциона в глобальной компьютерной сети Интернет, результатом которого становится право Победителя на приобретение Товара по Лоту.
                </p>
                <p>
                    <b>Аффилированные лица</b> – юридические лица, имеющие в составе своих учредителей лиц (физических и(или) юридических), находящихся в составе учредителей Дилера.
                </p>
                <p>
                    <b>Дилер(ы)</b> – юридическое лицо (юридические лица), с которым(и) у Организатора заключен дилерский договор, который также, одновременно, является участником программы Hyundai Certified.
                </p>
                <p>
                    <b>Лот</b> – размещенное на Сайте предложение Продавца о продаже Автомобиля, право на покупку которого приобретает Победитель Аукциона с указанием марки, модели, основных технических характеристик, комплектации, фактического состояния бывшего в эксплуатации автотранспортного средства, с размещенными фотографиями, отчетом об истории автотранспортного средства, электронной сервисной книжкой, диагностической картой по стандартам Hyundai Certified.
                </p>
                <p>
                    <b>Начальная цена</b> – стартовая цена Автомобиля по Лоту, устанавливаемая пользователем Аукциона (продавцом).
                </p>
                <p>
                    <b>Ставка</b> – повышение Начальной цены Лота фиксированными шагами в российских рублях. Минимальный шаг – 5 000 российских рублей.
                </p>
                <p>
                    <b>Окончательная цена</b> – наибольшая цена Автомобиля по Лоту, зафиксированная Организатором Аукциона по результатам его проведения.
                </p>
                <p>
                    <b>Организатор</b> – ООО «Хендэ Мотор СНГ».
                </p>
                <p>
                    <b>Отчетный период</b> - один календарный месяц.
                </p>
                <p>
                    <b>Правила</b> – настоящие Правила продажи автомобилей с пробегом на АУКЦИОНЕ HYUNDAI.
                </p>
                <p>
                    <b>Договор</b> – договор купли-продажи Автомобиля, заключаемый по результатам Аукциона между Продавцом и Покупателем.
                </p>
                <p>
                    <b>Сайт</b> – https://auction.hyundai.ru
                </p>
                <p>
                    <b>Участник</b> – юридическое лицо, являющееся Дилером или Аффилированным лицом, которое допущено к участию в Аукционе путем Регистрации на Сайте в лице его уполномоченного представителя.
                </p>
                <p>
                    <b>Продавец</b> – Участник, выставивший Автомобиль по Лоту на продажу.
                </p>
                <p>
                    <b>Покупатель</b> – Участник, предложивший наиболее высокую цену по Лоту в результате проведения Аукциона.
                </p>
                <p>
                    <b>Личный кабинет (ЛК)</b> – персональный раздел Участника на Сайте.
                </p>
                <p>
                    <b>Регистрация</b> – совокупность действий Участника, совершаемая в соответствии с указанными на Сайте инструкциями, с целью создания Личного кабинета и получения доступа к отдельным Сервисам Сайта.
                </p>
                <p>
                    <b>Учетные данные</b> – уникальный логин (адрес электронной почты) и пароль, создаваемые Участником в процессе регистрации на Сайте или изменяемые впоследствии через Личный кабинет. Эти данные используются для авторизации Участника и доступа в Личный кабинет.
                </p>
                <p>
                    1.2. Предметом Аукциона является Автомобиль, выставленный Продавцом в качестве Лота на Аукцион.
                </p>
                <p>
                    1.3. Для проведения Аукциона Организатор размещает Лот на Сайте. Каждый Автомобиль по Лоту выставляется на Аукцион в том виде, техническом состоянии и комплектности, в котором он находится на момент проведения Аукциона, с указанием пробега, дефектов и повреждений. На Автомобиле должны отсутствовать залоги, обременения и аресты.
                </p>
                <p>
                    1.4. Организатор обеспечивает работоспособность Сайта для проведения Аукциона.
                </p>
                <p>
                    1.5. Права и обязанности Организатора и Участника при проведении Аукционов определяются Правилами. Участник, осуществляя Регистрацию на Сайте, тем самым, соглашается с Правилами в полном объеме без каких-либо изъятий и оговорок.
                </p>
                <h2>
                    2. Регистрация учетной записи
                </h2>
                <p>
                    2.1. Процесс регистрации доступен только новым представителям дилерских центров, не имеющим подтвержденной учетной записи. Учетные записи действующих пользователей используют процедуру авторизации.
                </p>
                <p>
                    2.2. Процесс регистрации включает:
                </p>
                <p>
                    Переход на главную страницу Сайта (https://auction.hyundai.ru) и нажатие на кнопку «Регистрация».
                </p>
                <p>
                    2.3. Заполнение обязательных полей формы регистрации, включая:
                </p>
                <ul>
                    <li>Дилерский центр (с использованием поиска по наименованию или SAP-коду);</li>
                    <li>Адрес электронной почты (E-Mail);</li>
                    <li>Пароль и подтверждение пароля;</li>
                    <li>Фамилию, имя и отчество;</li>
                    <li>Должность;</li>
                    <li>Мобильный телефон.</li>
                </ul>
                <p>
                    Нажатие на кнопку «Зарегистрироваться».
                </p>
                <p>
                    2.4. После отправки формы система проверяет корректность заполнения всех обязательных полей. Если какие-либо поля не заполнены или заполнены некорректно, то система выделяет их визуально, чтобы Участник мог внести корректировки.
                </p>
                <p>
                    2.5. После успешного заполнения формы данные отправляются Организатору на верификацию и одобрение. Регистрация завершается созданием Личного кабинета и предоставлением доступа к Сервисам Сайта.
                </p>
                <h2>
                    3. Подготовка к проведению Аукциона
                </h2>
                <p>
                    3.1. Продавец:
                </p>
                <ul>
                    <li>производит диагностику Автомобиля по стандартам Hyundai Certified и загружает данные через личный кабинет АУКЦИОНA HYUNDAI на Сайте. Ответственность за внесение корректных данных несет Продавец.</li>
                    <li>агружает отчеты об истории Автомобиля Автокод (https://avtocod.ru/) либо Автотека (https://autoteka.ru/) (отчет должен быть сформирован не ранее 30 дней до проведения Аукциона).</li>
                    <li>с момента размещения анонса Организатором и до окончания Аукциона полностью прекращает размещение иных объявлений о продаже и/или рекламы на других площадках (АВИТО, Авто.ру и т.п.) </li>
                    <li>Загружает копию ПТС или ЭПТС.</li>
                    <li>Загружает полную цепочку документов до последнего собственника, регистрировавшего автомобиль в органах ГИБДД, в том числе копия СТС или копия ПТС. Данный пакет документов необходим для определения исчисления НДС при последующей перепродаже автомобиля. </li>
                </ul>
                <p>
                    3.2. Организатор:
                </p>
                <ul>
                    <li>проверяет внесенные Продавцом данные для автоматического формирования Лота по конкретному Автомобилю и, в случае обнаружения явных опечаток, очевидных неточностей в сведениях о спецификации, комплектации, описании Автомобиля, отсутствия диагностической карты, необходимого количества фото, отчета об истории Автомобиля, направляет уведомление Продавцу;</li>
                </ul>
                <p>
                    Если автомобиль, отправленный на согласование, не соответствует требованиям добавления автомобилей в систему, Организатор вносит комментарий с описанием причины и отклоняет заявку.
                </p>
                <p>
                    После отклонения статус автомобиля в системе сменится с "На утверждении" на "На доработке". Участнику, который добавил данный автомобиль, будет направлено соответствующее e-mail-уведомление о том, что его автомобиль не прошел модерацию. После внесения необходимых изменений Участник может отправить автомобиль на повторное согласование Организатору.
                </p>
                <ul>
                    <li>привлекает Покупателей для участия в Аукционе и регистрации на Сайте;</li>
                    <li>Организатор формирует аукцион, задавая дату и время его проведения, а также добавляет лоты в аукцион.</li>
                </ul>
                <p>
                    После формирования аукциона и добавления всех лотов организатор проводит рассылку анонса о предстоящем аукционе.
                </p>
                <p>
                    Анонс рассылается за один рабочий день до старта аукциона на электронные адреса участников, указанные в их личных кабинетах.
                </p>
                <p>
                    В рассылке содержится информация о предстоящем аукционе, включая дату и время его начала, а также список лотов, прикрепленный в виде файла.
                </p>
                <h2>4. Порядок проведения Аукциона</h2>
                <p>
                    4.1. Аукцион проводится на повышение цены.
                </p>
                <p>
                    4.2. При проведении Аукциона Участники делают Ставки. Текущая цена каждого Лота отражается в его описании.
                </p>
                <p>
                    4.3. Аукцион начинается в указанные на Сайте (на странице соответствующего Лота) дату и время и длится минимум 30 минут, при этом каждая последующая Ставка, сделанная за минуту до окончания Аукциона - продлевает его действие на 2 минуты.
                </p>
                <p>
                    4.4. Покупателем признается тот Участник Аукциона, чья Ставка являлась лидирующей на момент окончания Аукциона. Сделав Ставку, Участник принимает на себя обязательство по выкупу данного Лота у Продавца, в случае если его Ставка окажется лидирующей по завершению Аукциона.
                </p>
                <p>
                    4.5. По завершении аукциона система автоматически отправляет Результаты аукциона продавцу и победителю на адреса электронной почты, указанные при регистрации в Личном кабинете.
                </p>
                <p>
                    4.5.1. Для дилера-продавца на портале в разделе "Аукционы" отображается информация о лоте, включая:
                </p>
                <ul>
                    <li>Ставка победителя;</li>
                    <li>Сведения о победителе;</li>
                    <li>Кнопка «Подтвердить продажу».</li>
                </ul>
                <p>
                    Продавец обязан подтвердить свое намерение о продаже товара по лоту победителю аукциона. До момента подтверждения в личном кабинете победителя отображается статус «Ожидает результата».
                </p>
                <p>
                    4.5.2. После подтверждения продажи:
                </p>
                <p>
                    Система автоматически изменяет статус лота с «Ожидает результата» на «Завершен»;
                </p>
                <p>
                    Победителю отправляется электронное письмо с подтверждением победы, а также доступом к документам (договору купли-продажи и счету).
                </p>
                <p>
                    4.6. Если Аукцион завершился без единой Ставки, данный Лот выставляется повторно в течение двух последующих Аукционов.
                </p>
                <p>
                    4.7. Указанный в Объявлении о продаже Автомобиль не может участвовать в более чем трех Аукционах.
                </p>
                <h2>
                    5. Взаимоотношения Продавца и Организатора
                </h2>
                <p>
                    5.1. Продавец и Организатор заключают договор услуг по размещению на Сайте Объявлений о продаже Автомобилей, а также услуг по организации подготовки сделки купли-продажи между Продавцом и Покупателем.
                </p>
                <p>
                    5.2. Продавец оплачивает Организатору вознаграждение в размере и в сроки в соответствии с условиями заключенного с ним договора.
                </p>
                <p>
                    5.3. Факт заключения или не заключения Договора купли-продажи между Продавцом и Покупателем не влияет на обязанность Продавца по оплате суммы вознаграждения Организатору.
                </p>
                <h2>6. Взаимодействие Продавца и Покупателя</h2>
                <p>
                    6.1. По итогу Аукциона Продавец и Покупатель заключают Договор купли-продажи Автомобиля (далее также -ДКП).
                </p>
                <p>
                    6.2. Организатор предоставляет рекомендованную для использования форму ДКП, размещенную на Сайте. Однако, Продавец и Покупатель вправе использовать свою форму ДКП или вносить необходимые изменения в рекомендованную Организатором форму.
                </p>
                <p>
                    6.3. Сроки оплаты Автомобиля Покупателем, порядок передачи Автомобиля определяются условиями, прописанными в ДКП между Продавцом и Покупателем.
                </p>
                <p>
                    6.4. Продавец и Покупатель согласовывают действия и сроки по снятию Автомобиля с регистрационного учета в ГИБДД.
                </p>
                <p>
                    6.5. Организатор не несет ответственности по обязательствам Продавца и Покупателя в рамках исполнения ДКП.
                </p>
                <h2>7. Ответственность за нарушение Правил Аукциона</h2>
                <p>
                    В случае
                </p>
                <ul>
                    <li>если Участник указал заведомо ложные и недостоверные данные в Личном кабинете при регистрации на Сайте;</li>
                    <li>если Продавец или Покупатель отказался от заключения Договора купли-продажи без указания существенной причины (недостатка). Существенной причиной (недостатком) для отказа от заключения Договора купли-продажи Автомобиля по Лоту признается несоответствие (существенное расхождение) фактического состояния Автомобиля его описанию в Лоте (цвет кузова, наличие неисправностей, недостатков, повреждений);</li>
                    <li>если Покупатель отказывается оплатить Автомобиль, выставленный в качестве Лота на Аукцион, ставший предметом заключенного между Продавцом и Покупателем договора купли-продажи;</li>
                    <li>если Продавец отказывается передать Покупателю ставший предметом заключенного между Продавцом и Покупателем по результатам Аукциона договора купли-продажи</li>
                </ul>
                <p>
                    Участник по требованию Организатора выплачивает штраф в размере 50 (пятидесяти) тысяч рублей в течение 7 (семи) рабочих дней с момента направления указанного требования Организатора с использованием адресов электронной почты, указанных в Личном кабинете.
                </p>
                <p>
                    В случае если Участник не выполняет требование Организатора об оплате штрафа Организатору, такой Участник лишается права на участие в дальнейших Аукционах Организатора.
                </p>
                <h2>8. Заключительные положения</h2>
                <p>
                    8.1. Организатор доводит до сведения всех третьих лиц (действительных и потенциальных участников Аукциона) информацию о том, что предложение Организатора участвовать в Аукционе не является публичной офертой по смыслу ст. 437 Гражданского кодекса РФ.
                </p>
                <p>
                    8.2. Организатор настоящим подтверждает, что Аукцион не является торгами по смыслу ст. 447 ГК РФ, в отношении данных Правил по проведению Аукциона не применяются положения ст. 448, 449 ГК РФ.
                </p>
                <p>
                    8.3. Организатор вправе вносить в Правила изменения и дополнения, которые вступают в силу с момента опубликования на Сайте (добавим ссылку на сайт с разделом правила). Если после опубликования Участник не отказался от дальнейшего участия в Аукционе, то считается, что он согласен с данными изменениями и дополнениями.
                </p>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
    @use './ViewRules.scss' as *;
</style>
